export default function () {
    return {
        restrict: 'A',
        scope: {
            onScrollEnd: '&'
        },
        link(scope, el) {
            el.on('scroll', () => {
                const reachedEnd = el[0].offsetHeight + el[0].scrollTop >= el[0].scrollHeight;

                if (reachedEnd) {
                    scope.onScrollEnd();
                }
            });
        }
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/directives/onScrollEnd.js